import { Badge } from "@/components/ui/badge";

const statusColors: Record<string, string> = {
  active: "bg-green-100 text-green-700 border-green-200",
  pending: "bg-yellow-100 text-yellow-700 border-yellow-200",
  approved: "bg-green-100 text-green-700 border-green-200",
  rejected: "bg-red-100 text-red-700 border-red-200",
  deferred: "bg-blue-100 text-blue-700 border-blue-200",
  open: "bg-blue-100 text-blue-700 border-blue-200",
  in_progress: "bg-yellow-100 text-yellow-700 border-yellow-200",
  resolved: "bg-green-100 text-green-700 border-green-200",
  escalated: "bg-red-100 text-red-700 border-red-200",
  paid: "bg-green-100 text-green-700 border-green-200",
  unpaid: "bg-red-100 text-red-700 border-red-200",
  partial: "bg-yellow-100 text-yellow-700 border-yellow-200",
  overdue: "bg-red-100 text-red-700 border-red-200",
  published: "bg-green-100 text-green-700 border-green-200",
  draft: "bg-muted text-muted-foreground border-muted",
  pending_approval: "bg-blue-100 text-blue-700 border-blue-200",
  pending_verification: "bg-purple-100 text-purple-700 border-purple-200",
  verified: "bg-emerald-100 text-emerald-700 border-emerald-200",
  suspended: "bg-red-100 text-red-700 border-red-200",
  graduated: "bg-primary/10 text-primary border-primary/20",
  registered_active: "bg-green-100 text-green-700 border-green-200",
  registered_inactive: "bg-muted text-muted-foreground border-muted",
  unregistered_active: "bg-blue-100 text-blue-700 border-blue-200",
  unregistered_inactive: "bg-muted text-muted-foreground border-muted",
  postponed: "bg-orange-100 text-orange-700 border-orange-200",
  discontinued: "bg-red-100 text-red-700 border-red-200",
  deceased: "bg-gray-200 text-gray-700 border-gray-300",
  terminated: "bg-red-200 text-red-800 border-red-300",
  minor: "bg-yellow-100 text-yellow-700 border-yellow-200",
  moderate: "bg-orange-100 text-orange-700 border-orange-200",
  major: "bg-red-100 text-red-700 border-red-200",
  critical: "bg-red-200 text-red-800 border-red-300",
};

export function StatusBadge({ status }: { status: string }) {
  const colorClass = statusColors[status] || "bg-muted text-muted-foreground";
  return (
    <Badge variant="outline" className={colorClass}>
      {status.replace(/_/g, " ").replace(/\b\w/g, (l) => l.toUpperCase())}
    </Badge>
  );
}
